import axios from "axios";

const api = axios.create({
  baseURL: "URL_DA_API",
});

export default api;
